export default __webpack_public_path__ + "static/gc-ad-thumbnail-e0f8cf10098c465c526bb075e2676a40.png";